import React, { useState, useRef, useEffect } from "react";
import {
  Plus,
  Minus,
  Check,
  X,
  Users,
  Baby,
  Utensils,
  Heart,
  Send,
} from "lucide-react";

const RSVPForm = ({ t }) => {
  const [attending, setAttending] = useState(null);
  const [adults, setAdults] = useState([
    { id: Date.now(), firstName: "", lastName: "" },
  ]);
  const [children, setChildren] = useState([]);
  const [dietary, setDietary] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState({ loading: false, success: false });
  const formRef = useRef(null);
  const addAdult = () =>
    setAdults([...adults, { id: Date.now(), firstName: "", lastName: "" }]);
  const removeAdult = (id) => setAdults(adults.filter((a) => a.id !== id));
  const updateAdult = (id, field, value) => {
    setAdults(adults.map((a) => (a.id === id ? { ...a, [field]: value } : a)));
  };

  const addChild = () =>
    setChildren([
      ...children,
      { id: Date.now(), firstName: "", lastName: "", age: "" },
    ]);
  const removeChild = (id) => setChildren(children.filter((c) => c.id !== id));
  const updateChild = (id, field, value) => {
    setChildren(
      children.map((c) => (c.id === id ? { ...c, [field]: value } : c)),
    );
  };

  useEffect(() => {
    if (status.success && formRef.current) {
      // Promjena: block: "center" postavlja element na sredinu ekrana
      formRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [status.success]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (attending === null) return alert("Molimo označite dolazite li ili ne.");

    setStatus({ loading: true, success: false });

    // Simulacija slanja
    console.log("Podaci za Resend:", {
      attending,
      adults,
      children,
      dietary,
      message,
    });
    setTimeout(() => {
      setStatus({ loading: false, success: true });
    }, 2000);
  };

  if (!t) return null;

  return (
    <section className="rsvp-section" id="rsvp" ref={formRef}>
      <div className="container">
        {status.success ? (
          // PORUKA USPJEHA (Sada je unutar sekcije s ref-om)
          <div className="rsvp-success-msg fade-in">
            <Heart size={48} color="#d4a373" fill="#d4a373" />
            <h2 className="serif-font">{t.rsvpSuccessTitle}</h2>
            <p className="serif-font">{t.rsvpSuccessMsg}</p>
          </div>
        ) : (
          <>
            <h2 className="script-font">{t.rsvpTitle}</h2>

            <form className="dynamic-rsvp-form" onSubmit={handleSubmit}>
              {/* 1. DOLAZIM / NE DOLAZIM */}
              <div className="attending-toggle">
                <button
                  type="button"
                  className={`choice-btn ${attending === "yes" ? "active-yes" : ""}`}
                  onClick={() => setAttending("yes")}
                >
                  <Check size={18} /> {t.rsvpYes}
                </button>
                <button
                  type="button"
                  className={`choice-btn ${attending === "no" ? "active-no" : ""}`}
                  onClick={() => setAttending("no")}
                >
                  <X size={18} /> {t.rsvpNo}
                </button>
              </div>

              {/* 2. ODRASLI GOSTI (Uvijek vidljivo) */}
              <div className="guest-section">
                <label className="section-label serif-font">
                  <Users size={18} />{" "}
                  {attending === "no" ? "TKO OTKAZUJE?" : "ODRASLI GOSTI"}
                </label>
                {adults.map((adult, index) => (
                  <div key={adult.id} className="guest-card fade-in">
                    <div className="inputs-wrapper">
                      <input
                        placeholder={t.rsvpFirstName}
                        required
                        value={adult.firstName}
                        onChange={(e) =>
                          updateAdult(adult.id, "firstName", e.target.value)
                        }
                      />
                      <input
                        placeholder={t.rsvpLastName}
                        required
                        value={adult.lastName}
                        onChange={(e) =>
                          updateAdult(adult.id, "lastName", e.target.value)
                        }
                      />
                    </div>
                    {adults.length > 1 && (
                      <button
                        type="button"
                        className="remove-btn"
                        onClick={() => removeAdult(adult.id)}
                      >
                        <Minus size={14} /> {t.rsvpRemove}
                      </button>
                    )}
                  </div>
                ))}
                <button type="button" className="add-btn" onClick={addAdult}>
                  <Plus size={16} /> {t.rsvpAddAdult}
                </button>
              </div>

              {/* 3. DJECA (Uvijek vidljivo) */}
              <div className="guest-section">
                <label className="section-label serif-font">
                  <Baby size={18} /> {t.rsvpChildrenTitle}
                </label>
                {children.map((child) => (
                  <div key={child.id} className="guest-card fade-in">
                    <div className="inputs-wrapper">
                      <input
                        placeholder={t.rsvpChildName}
                        value={child.firstName}
                        onChange={(e) =>
                          updateChild(child.id, "firstName", e.target.value)
                        }
                      />
                      <input
                        className="age-input"
                        placeholder={t.rsvpChildAge}
                        value={child.age}
                        onChange={(e) =>
                          updateChild(child.id, "age", e.target.value)
                        }
                      />
                    </div>
                    <button
                      type="button"
                      className="remove-btn"
                      onClick={() => removeChild(child.id)}
                    >
                      <Minus size={14} /> {t.rsvpRemove}
                    </button>
                  </div>
                ))}
                <button type="button" className="add-btn" onClick={addChild}>
                  <Plus size={16} /> {t.rsvpAddChild}
                </button>
              </div>

              {/* 4. DODATNA POLJA (Samo ako dolazi) */}
              {attending !== "no" && (
                <div className="extra-info fade-in">
                  <label className="section-label serif-font">
                    <Utensils size={18} />
                    {t.rsvpDietaryTitle}
                  </label>
                  <textarea
                    placeholder={t.rsvpDietaryPlaceholder}
                    value={dietary}
                    onChange={(e) => setDietary(e.target.value)}
                  />
                </div>
              )}

              {/* 5. PORUKA (Uvijek vidljivo) */}
              <div className="extra-info">
                <label className="section-label serif-font">
                  {t.rsvpMessageTitle}
                </label>
                <textarea
                  placeholder={t.rsvpMessagePlaceholder}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>

              <div className="consent-box">
                <input type="checkbox" id="consent" required />
                <label htmlFor="consent" className="serif-font">
                  {t.rsvpConsentText}
                </label>
              </div>

              <button
                type="submit"
                className="submit-btn serif-font"
                disabled={status.loading}
              >
                {status.loading ? (
                  t.rsvpSending
                ) : (
                  <>
                    <Send size={16} /> {t.rsvpSubmit}
                  </>
                )}
              </button>
            </form>
          </>
        )}
      </div>
    </section>
  );
};

export default RSVPForm;
